/* SKNTIDES — Shopify Theme JS */

document.addEventListener('DOMContentLoaded', function () {

  // ── Nav scroll effect ──
  const nav = document.querySelector('.skn-nav');
  if (nav) {
    window.addEventListener('scroll', function () {
      if (window.scrollY > 40) {
        nav.classList.add('scrolled');
      } else {
        nav.classList.remove('scrolled');
      }
    }, { passive: true });
  }

  // ── Mobile menu toggle ──
  const mobileBtn = document.querySelector('.nav-mobile-btn');
  const mobileMenu = document.querySelector('.nav-mobile-menu');
  if (mobileBtn && mobileMenu) {
    mobileBtn.addEventListener('click', function () {
      mobileMenu.classList.toggle('open');
    });
  }

  // ── Scroll reveal ──
  const revealEls = document.querySelectorAll('.reveal');
  if (revealEls.length > 0) {
    const observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        }
      });
    }, { threshold: 0.12 });
    revealEls.forEach(function (el) { observer.observe(el); });
  }

  // ── Cart count badge ──
  function updateCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var badges = document.querySelectorAll('.cart-count');
        badges.forEach(function (b) {
          b.textContent = cart.item_count;
          b.style.display = cart.item_count > 0 ? 'flex' : 'none';
        });
      })
      .catch(function () {});
  }
  updateCartCount();

  // ── Add to cart (AJAX) ──
  document.querySelectorAll('.js-add-to-cart').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var variantId = btn.dataset.variantId;
      if (!variantId) return;
      btn.disabled = true;
      var originalText = btn.querySelector('span') ? btn.querySelector('span').textContent : btn.textContent;
      if (btn.querySelector('span')) btn.querySelector('span').textContent = 'Adding...';
      else btn.textContent = 'Adding...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          if (btn.querySelector('span')) btn.querySelector('span').textContent = 'Added!';
          else btn.textContent = 'Added!';
          updateCartCount();
          setTimeout(function () {
            if (btn.querySelector('span')) btn.querySelector('span').textContent = originalText;
            else btn.textContent = originalText;
            btn.disabled = false;
          }, 1500);
        })
        .catch(function () {
          if (btn.querySelector('span')) btn.querySelector('span').textContent = originalText;
          else btn.textContent = originalText;
          btn.disabled = false;
        });
    });
  });

});
